import {Component}                            from "@angular/core";
import {ModalController, NavController}       from "@ionic/angular";
import {DataStore, SortDirection}             from "@aws-amplify/datastore";
import {SupportRequest, Ticket, TicketStatus} from "../../models";
import {SessionService}                       from "../services/session.service";
import {Router}                               from "@angular/router";
import {NewTicketComponent}                   from "../components/new-ticket/new-ticket.component";

@Component({
    selector: "app-support",
    templateUrl: "./support.page.html",
    styleUrls: ["./support.page.scss"],
})
export class SupportPage {
    public oggett = "";
    public message = "";
    loading = false;
    chats = [];
    archivedChats = [];
    allChats = [];
    segment = "msg";

    constructor(
            public router: Router,
            private navController: NavController,
            public sessionService: SessionService,
            public modalController: ModalController
    ) {
    }

    async ionViewDidEnter() {

        await this.prepareObserver();
    }

    prepareObserver() {
        let ChatObserve;

        if (
                this.sessionService.user?.permessions ==
                this.sessionService.permessionTypes.CLIENT
        ) {
            DataStore.observeQuery(Ticket,
                    condition => condition.ticketClientId('eq', this.sessionService.user.id)).subscribe(x => {
                this.refreshTickets(x.items);
            });

        } else if (this.sessionService.user?.permessions ==
                this.sessionService.permessionTypes.COMMERCIAL
        ) {
            DataStore.observeQuery(Ticket).subscribe(x => {
                let chats = x.items?.filter(x => x.client?.addedBy == this.sessionService.user?.id)
                this.refreshTickets(chats);
            })
        } else {

            DataStore.observeQuery(Ticket).subscribe(y => {
                this.refreshTickets(y.items);
            });
        }

    }

    async refreshTickets(listChats) {
        this.chats = [];
        let c: Ticket;
        for (const chat of listChats) {
            let msg = await DataStore.query(SupportRequest, x => x.ticketId('eq', chat.id),
                    {sort: condition => condition.createdAt(SortDirection.DESCENDING)});
            let lastmsg = null;
            let createdAt: string = null;
            let isClient = false;
            if (msg.length > 0) {
                lastmsg = msg[0].message;
                createdAt = msg[0].createdAt;
                isClient = (msg[0].fromUser?.id == chat.ticketClientId);
            }
            this.chats.push({
                ...chat,
                messsage: lastmsg,
                createdAt: createdAt,
                isClient
            });

        }
        this.chats = this.chats.sort((a, b) => b.createdAt.localeCompare(a.createdAt))

        this.archivedChats = this.chats.filter((x: Ticket) => x.ticketStatus == TicketStatus.ARCHIVED).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
        this.allChats = this.chats.filter((x: Ticket) => x.ticketStatus != TicketStatus.ARCHIVED).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
        
        const key = "ticketId";


    }

    back() {
        this.navController.back();
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    goToAgentChat(ticketId: string) {
        this.router.navigate(["/agent-support-chat", ticketId]);
    }

    async newTicket() {
        const modal = await this.modalController.create({
            component: NewTicketComponent,
            //   componentProps: {userId: null, isClient: false},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {

        });

    }

    async archive(id: string) {
        const t = await DataStore.query(Ticket, id);
        await DataStore.save(Ticket.copyOf(t, u => {
            u.ticketStatus = TicketStatus.ARCHIVED;
        }));

    }

    segmentChanged($event: any) {
        
        this.segment = $event.target.value;

    }

    async unArrchive(id) {
        const t = await DataStore.query(Ticket, id);
        await DataStore.save(Ticket.copyOf(t, u => {
            u.ticketStatus = TicketStatus.OPEND;
        }));
    }
}
